import { queryOptions } from '@tanstack/react-query';

import { SnakeIdObj } from '@synapex/tools/typescript';

import * as Api from '../api-client';
import { WorkspaceDescriptor } from '@synapex/shared2/entities';

export const channelRequest = (
  ...args: Parameters<typeof Api.ChannelRequest.getOne>
) => {
  const [{ telegram_channel_id }] = args;
  const { queryKey, queryFn } = queryOptions({
    queryKey: ['channel-request', telegram_channel_id],
    queryFn: () => Api.ChannelRequest.getOne({ telegram_channel_id }),
  });

  return {
    queryKey,
    queryFn,
  };
};

export const all = () => {
  const { queryKey, queryFn } = queryOptions({
    queryKey: ['advertiser-account'],
    queryFn: Api.all,
  });

  return {
    queryKey,
    queryFn,
  };
};

export const users = ({
  advertiser_account_id,
}: SnakeIdObj<'advertiser_account'>) => {
  const { queryKey, queryFn } = queryOptions({
    queryKey: ['advertiser-account', advertiser_account_id, 'users'],
    queryFn: () =>
      Api.users({
        advertiser_account_id,
      }),
  });

  return {
    queryKey,
    queryFn,
  };
};

export const workspaceUsers = ({
  workspace_type,
  workspace_id,
}: WorkspaceDescriptor) => {
  const { queryKey, queryFn } = queryOptions({
    queryKey: [
      'advertiser-account',
      'workspace',
      workspace_type,
      workspace_id,
      'users',
    ],
    queryFn: () =>
      Api.workspaceUsers({
        workspace_type,
        workspace_id,
      }),
  });

  return {
    queryKey,
    queryFn,
  };
};
